export default {
  loading(state) {
    return state.loading;
  },
  currentUser(state) {
    return state.currentUser;
  },
  banner(state) {
    return state.banner;
  },
  lockedUsersByNotifications(state) {
    return state.notifications.lockedUsers;
  },
  supportRequestsByNotifications(state) {
    return state.notifications.supportRequests;
  },
};
